export default {
  COLOR: 'color',
  THICKNESS: 'thickness',
  BORDER_RADIUS: 'border-radius',
  PADDING: 'padding',
  PADDING_VERTICAL: 'padding-vertical',
  PADDING_HORIZONTAL: 'padding-horizontal',
};
